import { Report } from 'shared'
import CIMSSelect from '..'
import { useOptions } from '../hooks/useOptions'
import { CommonSelect } from './types'

/**
 * a simple {@link CIMSSelect} using Report options
 *
 * the value will map to a ReportItem.id, string, value(s) depending on the configuration
 */
const ReportSelect: React.FC<CommonSelect<'simple'>> = (props) => {
  const options = useOptions({
    items: Report.clientReports,
    value: 'id',
    label: 'name',
    sort: 'name',
  })
  return <CIMSSelect simple {...props} options={options} />
}

export default ReportSelect
